import React from 'react';
import { motion } from 'framer-motion';
import { volumes } from '../data/content';
export function VolumesSection() {
  return <section className="w-full bg-navy px-5 py-12 sm:py-20" data-id="element-250" data-mp="3utm4aq96wfw5">
      <div className="mx-auto max-w-5xl" data-id="element-251" data-mp="cp0ykb16my7v">
        <div className="mx-auto max-w-2xl text-center" data-id="element-252" data-mp="cnzexi63p3ej">
          <h2 className="font-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-253" data-mp="7owk0qju4dka">
            6 Complete Teaching Volumes
          </h2>
          <p className="mt-3 text-sm text-white/70 sm:text-base" data-id="element-254" data-mp="3g5hlzne1u6dw">
            Structured, ready-to-use content across A1, A2, and B1 levels.
          </p>
        </div>
        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-2" data-id="element-255" data-mp="3pw2o3ksxlt1k">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-4 rounded-2xl border border-gold/35 bg-navy-mid p-5 shadow-sm shadow-black/25 sm:gap-6 sm:p-7" data-id="element-256" data-mp="3l2rhnks17ea6" data-mpi={index}>
              <div className="flex min-w-0 flex-1 flex-col" data-id="element-257" data-mp="2j5k2hkhevmjo">
                <span className="font-display text-3xl font-bold leading-none text-gold sm:text-4xl" data-id="element-258" data-mp="2j63hasbrluth">
                  {volume.number}
                </span>
                <h3 className="mt-3 text-base font-bold leading-snug text-white sm:text-lg" data-id="element-259" data-mp="1qhfqkh88yd8j">
                  {volume.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-white/70" data-id="element-260" data-mp="1vhttjkuzqwzp">
                  {volume.description}
                </p>
                <span className="mt-5 inline-block w-fit rounded-full bg-gold/15 px-3 py-1 text-xs font-medium text-gold" data-id="element-261" data-mp="24gxe6t9t3kgb">
                  {volume.tag}
                </span>
              </div>
              <div className="shrink-0 self-start rounded-xl bg-navy p-1.5 ring-1 ring-gold/30" data-id="element-262" data-mp="3fv1e0g32s2ta">
                <img src={volume.coverImage} alt={`Cover of volume ${volume.number}: ${volume.title}`} width="108" height="162" loading="lazy" decoding="async" className="block h-[132px] w-[88px] rounded-lg object-cover shadow-[0_8px_16px_-7px_rgba(0,0,0,0.65)] sm:h-[162px] sm:w-[108px]" data-id="element-263" data-mp="1gqb3g6lttzup" />
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}